<template>
    <div>
        <h3>Position Planner <tool-tip >
        <p>This tool allows you to position how crafts will be displayed on the scheduling screen.</p>
        <p>The left-most column is crafts that have not yet been placed in position. Each column represents a group,
            and then crafts within a group can be sorted from top to bottom in their desired order within that group.</p>
        <p>Note that if, in a given shift in a requisition, the crafts are not used, they will not show on the scheduling screen.</p>
        </tool-tip></h3>
        <div ref="plan_space" class="planner-space">
            <div class="planner-column"  @dragover.prevent @drop="dragDropped(-1)">
				<h4 class="uk-text-center">Not Grouped</h4>
                <div v-for="craft in unsorted" draggable="true" class="craft-item" :style="'border-color:'+color+';color:'+color+';'"
                     @dragstart="startDrag(craft)"
                     @dragend="endDrag(craft)"
                     :key="craft.id"
                >
                    {{ craft.name }}
                </div>
            </div>
            <div v-for="(column, i) in activeColumns" class="planner-column" @dragover.prevent="test" @drop="dragDropped(i)">
                <h4 class="uk-text-center">Group {{ (i+1) }}</h4>
				<div v-for="(craft, j) in column" draggable="true" class="craft-item" :style="'border-color:'+color+';color:'+color+';'"
                     @dragover.prevent="test2"
                     @drop.stop.prevent="dragDropped(i, j)"
                     @dragstart="startDrag(craft)"
                     @dragend="endDrag(craft)"
                     :key="craft.id"
                >
                    {{ craft.name }}
                </div>
                <div class="drop-target">+</div>
            </div>
        </div>
    </div>
</template>

<script>
import ToolTip from "./ToolTip";
export default {
    name: "PositionPlanner",
    components: {
        ToolTip
    },
	props:{
    	color:{
    		type: String,
			default: "#484848"
		}
	},
    data() {
        return {
            activeColumns:[],
            unsorted:[],
            draggingCraft: null
        }
    },
    mounted() {
    	console.log(this.color);
        axios.get("/api/craft/list/sorted").then(
            (pack) => this.sortData(pack),
            () => this.catchFailure()
        );
    },
    methods: {
        sortData(pack){
            if(pack.data && pack.data.success){
                let items = pack.data.data;
                for(let i = 0; i < items.length;++i){
                    let item = items[i];
                    if(item.position_x == null){
                        this.unsorted.push(item);
                    } else {
                        if(typeof this.activeColumns[item.position_x] === 'undefined'){
                            //fill the array till we have that column
                            while(this.activeColumns.length <= item.position_x){
                                this.activeColumns.push([]);
                            }
                        }
                        if(typeof this.activeColumns[item.position_x][item.position_y] === 'undefined'){
                            //fill the column until we have that slot
                            while(this.activeColumns[item.position_x].length <= item.position_y){
                                this.activeColumns[item.position_x].push({id:null,name:"XXX"});
                            }
                        }
                        this.activeColumns[item.position_x][item.position_y] = item;
                    }
                }
                this.activeColumns.push([]); //add a blank column at the end
            }
            this.$forceUpdate();
            setTimeout(() => this.sizeColumns(), 10);
        },
        catchFailure(){

        },
        sizeColumns(){
            let numColumns = this.activeColumns.length +1;
            this.$refs.plan_space.style['grid-template-columns'] = "repeat("+numColumns+", 1fr)";
        },
        startDrag(craft) {
            //console.log(craft, "start");
            this.draggingCraft = craft;
        },
        endDrag(craft) {
            //console.log(craft, "end");
        },
        dragDropped(colIndex, itemIndex = null) {
            if(colIndex === -1){ // add to unsorted items
                let found = false;
                for(let i = 0; i < this.unsorted.length;++i){
                    if(this.unsorted[i].id == this.draggingCraft.id){
                        found = true;
                    }
                }
                !found ? this.unsorted.push(this.draggingCraft):null;
                //remove from current column, if in there
                for(let i = 0; i < this.activeColumns.length;++i){
                    for(let j = 0; j < this.activeColumns[i].length;++j){
                        if(this.activeColumns[i][j] && this.activeColumns[i][j].id === this.draggingCraft.id){
                            this.activeColumns[i].splice(j, 1);
                            if(this.activeColumns[i].length === 0){
                                this.activeColumns.splice(i, 1);
                            }
                            break;
                        }
                    }
                }
            }
            else{
                if(itemIndex !== null){ // add to column placing at itemIndex
                    this.activeColumns[colIndex].splice(itemIndex, 0, this.draggingCraft);
                } else { //push at end of column
                    this.activeColumns[colIndex].push(this.draggingCraft);
                    itemIndex = this.activeColumns[colIndex].length -1; //so that the removal will remove old instance, not this one
                }
                //remove from unsorted, if present
                for(let i = 0; i < this.unsorted.length;++i){
                    if(this.unsorted[i].id == this.draggingCraft.id){
                        this.unsorted.splice(i, 1);
                        break;
                    }
                }
                //remove from old location, if needed
                for(let i = 0; i < this.activeColumns.length;++i){
                    for(let j = 0; j < this.activeColumns[i].length;++j){
                        if(this.activeColumns[i][j]
                            && this.activeColumns[i][j].id === this.draggingCraft.id
                            && (i != colIndex || j != itemIndex)
                        ){
                            this.activeColumns[i].splice(j, 1);

                            break;
                        }
                    }
                }
                //clear empty columns -- yes we need another pass to safely do this
                for(let i = 0; i < this.activeColumns.length;++i){
                    if(this.activeColumns[i].length === 0){
                        this.activeColumns.splice(i, 1);
                    }
                }

                //add column, if needed
                if(this.activeColumns[this.activeColumns.length-1].length > 0){
                    this.activeColumns.push([]);
                }
            }
            this.sizeColumns();
            //send updated data to the server
            this.sendPositions();

            this.$forceUpdate();
        },
        sendPositions(){
            let unsorted = [];
            let sorted = [];
            for(let i = 0; i < this.unsorted.length;++i){
                if(this.unsorted[i] && this.unsorted[i].id && this.unsorted[i].id !== 0){
                    unsorted.push(this.unsorted[i].id);
                }
            }
            for(let i = 0; i < this.activeColumns.length;++i){
                if(this.activeColumns[i] && this.activeColumns[i].length > 0){
                    for(let j = 0; j < this.activeColumns[i].length;++j){
                        if(this.activeColumns[i][j] && this.activeColumns[i][j].id && this.activeColumns[i][j].id !== 0){
                            sorted.push({
                                id: this.activeColumns[i][j].id,
                                x: i,
                                y: j
                            });
                        }
                    }
                }
            }

            axios.post("/api/craft/list/sort", {
                unsorted: unsorted,
                sorted: sorted
            }).then(
                (pack) => function(pack){console.log(pack);},
                (pack) => function(pack){console.log(pack);},
            );
        },
        test(){
            //console.log("test");
        },
        test2(){
            //console.log("test 2");
        }
    },
	computed:{
		cssVars(){
    		return {
    			"--color": this.color
			}
		}
	}
}
</script>
<style lang="less" scoped>
.planner-space{
    width: 100%;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
}
.planner-column{
    /*display:table-column;*/
    margin: 0;
    min-height: 50px;
}
.drop-target{
    border: thin dashed #adadad;
    border-radius: 5px;
    box-sizing: border-box;
	color: #adadad;
    width: 98%;
    margin: 3px auto;
    padding: 10px;
    text-align: center;
}
.craft-item{
    border: thin solid;
    background-color: #fff;
    border-radius: 5px;
    box-sizing: border-box;
    width: 98%;
    margin: 3px auto;
    padding: 10px;
    text-align: center;
    z-index: 20;
}
</style>
